export default __webpack_public_path__ + "static/media/Edge HL - Flag Preferred Member.svg";